import Container from 'app/components/UI-Elements/Layout/Container'
import * as React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import QuoteInvalid from './Invalid'
import QuotePaid from './Paid'

type Props = {
  quote: IQuote
  children?: React.ReactNode
}

const getError = (quote: IQuote) => {
  if (!quote) return null
  if (quote.status === 'accepted') return 'quote-already-paid'
  if (!quote.valid) return 'quote-not-valid'
}

const QuoteError: React.FC<Props> = ({ quote, children }) => {
  const { search, pathname } = useLocation()
  const error = getError(quote)

  if (error && !search.includes('errorType')) {
    const newSearch = new URLSearchParams(search)
    newSearch.append('errorType', error)

    return <Navigate to={{ pathname, search: String(newSearch) }} />
  }

  return (
    <Choose>
      <When condition={error === 'quote-already-paid'}>
        <Container>
          <QuotePaid member={quote} />
        </Container>
      </When>
      <When condition={error === 'quote-not-valid'}>
        <Container>
          <QuoteInvalid member={quote} />
        </Container>
      </When>
      <Otherwise>{children}</Otherwise>
    </Choose>
  )
}

export default QuoteError
